import { createContext } from 'react';

export type DeleteGroupCtx = {
  showDeleteGroupErrorAlert: boolean;
  deleteGroupError: string;
};

const DeleteGroupDialogueContext = createContext<DeleteGroupCtx>({
  showDeleteGroupErrorAlert: false,
  deleteGroupError: '',
});

export default DeleteGroupDialogueContext;